










import { Component, Vue } from 'vue-property-decorator';
import { TagsViewModule } from '@/store/modules/tagsView';

@Component
export default class AppMain extends Vue {
  get cachedViews() {
    return TagsViewModule.cachedViews;
  }
  get key(): string {
    return this.$route.path;
  }
}
